<template>
	<div class="step3" data-config-step="3">
		<div v-if="isLoading" class="loading">
			<p class="text-center front">CALCULATING</p>
			<div class="overlay-bg"/>
		</div>
		<div class="container">
			<div class="step3__performance">
				<game-fps-list
					v-if="gamesFps"
					:games="selectedGames"
					:games-fps="gamesFps"
					:resolution-text="resolutionText"
				/>
				<a
					alt="Back"
					title="Back"
					href="/bld/step2"
					class="back-step visible-lg visible-md"
				>
					<i aria-hidden="true" class="back-step-ico">
						<img src="/images/icons/back-ico.svg" alt="" width="30">
					</i>
				</a>
			</div>
			<div class="step3__specs">
				<h2 class="step3__heading">{{ selectedBuild.cases }}</h2>
				<step3-build-specs v-if="selectedBuild" :build-specs="selectedBuild" />
			</div>
			<div class="step3__select">
				<step3-select-budget
					v-if="selectedBuildIndex != null"
					:build-options="recommendedBuilds"
					:build="selectedBuild"
					:slide-index="selectedBuildIndex"
					:configure-or-checkout="linkToConfigurator"
					@cpu-model="selectedCpu"
					@current-build="activeBuild"
				/>
			</div>
			<div class="step3__includes">
				<hr>
				<div class="includes-loading">
					<div v-if="isMobileLoading" class="loading">
						<p class="text-center front">Loading</p>
						<div class="overlay-bg"/>
					</div>
					<build-includes v-if="selectedBuildDetails && isMobile" :active-build="selectedBuildDetails" />
				</div>
				<covid-19>
					<template v-slot:current>
						<build-note class="estimated-shipping-space">
							<p class="build-note__text">
								Estimated shipping date {{ shippingDate }}
							</p>
						</build-note>
					</template>
					<template v-slot:covid>
						<build-note class="estimated-shipping-space">
							<p class="build-note__text" />
						</build-note>
					</template>
				</covid-19>
			</div>
		</div>
		<div id="trans-div" class="trans-div trans-div-styles" />
		<div
			v-if="showLoadingOverlay"
			id="general-overlay"
			class="overlay"
			style="display:block;"
		/>
		<div v-if="showLoadingOverlay" class="loading">
			<p>{{ loadingText }}</p>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import Step3BuildSpecs from "./step3-build-specs";
import Step3SelectBudget from "./step3-select-budget";
import BuildIncludes from "../step-5/build-includes";
import BuildNote from "../step-5/build-note";
import GameFpsList from "../game-fps-list";
import Covid19 from "@c/covid-19";
import { heapAnalytics } from "@u/mixins.js";
import { isMobile } from "@u/helpers";
import { gtmTrack, gtmSaveCartTotal } from "@/util/gtm";

export default {
	name: "BuildPcStep3",
	components: {
		Step3BuildSpecs,
		Step3SelectBudget,
		BuildIncludes,
		BuildNote,
		GameFpsList,
		Covid19
	},
	mixins: [
		heapAnalytics
	],
	data() {
		return {
			gamesFps: {},
			price: 0,
			cpu: "intel",
			defaulBuild: 0,
			builds: [],
			recommendedBuilds: [],
			selectedBuild: {},
			selectedBuildDetails: {},
			selectedBuildIndex: null,
			selectedGames: [],
			isMobile: false,
			isLoading: true,
			isMobileLoading: false,
			resolution: "",
			resolutionText: "",
			shippingDate: ""
		};
	},
	computed: {
		...mapState({
			loadingText: state => state.Step4.loadingText,
			showLoadingOverlay: state => state.Step4.showLoadingOverlay
		})
	},
	created() {
		this.price = this.$route.query.price;
		if (!CONFIG || !CONFIG.SESSION || !this.price) {
			this.$router.push({
				name: "step1"
			});
		} else {
			this.getSessionData();
		}
		this.isMobile = isMobile();
	},
	methods: {
		selectedCpu(cpu) {
			this.recommendedBuilds = this.builds[cpu];
			this.cpu = cpu;
			this.approximateBuildPrice(this.selectedBuild.price);
			this.getGamesFps(this.selectedBuild);
		},
		activeBuild(index) {
			this.selectedBuild = this.recommendedBuilds[index];
			this.getSelectedBuildDetails();
			this.getGamesFps(this.selectedBuild);
		},
		approximateBuildPrice(priceRange) {
			const approximateBuild = this.recommendedBuilds.reduce((prev, curr) => {
				return (Math.abs(curr["price"] - priceRange) < Math.abs(prev["price"] - priceRange) ? curr : prev);
			});
			this.selectedBuildIndex = this.recommendedBuilds.indexOf(approximateBuild);
			this.selectedBuild = approximateBuild;
		},
		getSessionData() {
			axios({
				url: `/store/bld/steps/3/${ this.price }?session=${ CONFIG.SESSION }`,
				method: "GET",
				responseType: "json"
			}).then(response => {
				this.builds = response.data.builds;
				this.recommendedBuilds = response.data.builds[this.cpu];
				this.selectedGames = response.data.games;
				this.resolution = response.data.resolution;
				this.resolutionText = response.data.resolutionText;
				this.approximateBuildPrice(this.price);
				this.getGamesFps(this.selectedBuild);
				this.getSelectedBuildDetails();
				this.getShippingDate();
			}).catch(() => {
				toastr.warning("You should select at least one game", "No games selected");
				this.$router.replace({ name: "step1" });
			});
		},
		getSelectedBuildDetails() {
			if (this.isMobile) {
				this.isMobileLoading = true;
				axios({
					url: `/details/${ this.selectedBuild.id }?session=${ CONFIG.SESSION }`,
					method: "GET",
					responseType: "json"
				}).then(response => {
					this.selectedBuildDetails = response.data.defaultBuild;
					this.isMobileLoading = false;
				});
			}
			this.isLoading = false;
		},
		getGamesFps(buildData) {
			axios({
				method: "GET",
				url: `/games-fps?cpu=${ buildData.cpus_products_id }&gpu=${ buildData.gpus_products_id }&resolution=${ this.resolution }`,
				headers: {
					"token": CONFIG.SESSION
				}
			})
				.then(response => {
					this.gamesFps = response.data;
				}).catch(() => {
					toastr.warning("You should select at least one game", "No games selected");
					this.$router.replace({ name: "step1" });
				});
		},
		getShippingDate() {
			axios({
				url: `/shipping-date/${ this.selectedBuild.services_products_id.toString().slice(-1) }`,
				headers: {
					token: CONFIG.SESSION
				}
			}).then((response) => {
				this.shippingDate = response.data.date;
			});
		},
		linkToConfigurator(build, checkout = false) {
			this.$store.dispatch("changeShowLoadingOverlay", true);
			axios({
				url: `/details/${ build.id }?cpu=${ this.cpu }&resolution=${ this.resolution }&mobile=true&session=${ CONFIG.SESSION }`,
				method: "GET",
				responseType: "json"
			}).then(async(response) => {
				let step = this.isMobile ? "step4-mobile" : "step4";

				if (checkout) {
					this.trackAll("Client: Click Checkout 1");
					step = "step5";
				} else {
					this.trackAll("Client: Click Configure 1");
				}

				this.trackGTM(checkout);
				gtmSaveCartTotal(this.selectedBuild.price);
				window.localStorage.setItem("session-price", this.price);
				window.localStorage.setItem("session-draft", response.data);
				this.$store.dispatch("changeUserDraftId", response.data);
				await this.$store.dispatch("changeDraftId", null);
				await this.$store.dispatch("setActiveBuild", {});
				await this.$store.dispatch("changeSessionDataInfo", {});
				await this.$store.dispatch("setBuildPrice", 0);
				await this.$store.dispatch("resetDisableRules");
				this.$store.dispatch("changeShowLoadingOverlay", false);

				this.$router.push({
					name: step,
					query: {
						price: this.price,
						draft: response.data
					}
				});
			}).catch(() => {
				this.$store.dispatch("changeShowLoadingOverlay", false);
			});
		},
		trackGTM(checkout) {
			if (checkout) {
				gtmTrack.selectedProcessor(this.cpu);
			}
			gtmTrack.skipConfigStep(checkout);
		}
	}
};
</script>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.step3 {
    padding-top: 50px;

    @media (max-width: 1199px) {
        padding-top: 15px;
    }

    .estimated-shipping-space {
        margin-bottom: 50px;
    }

    .trans-div-styles {
        position: fixed;
        background: transparent;
        left:0;
        right:0;
        bottom:0;
        min-height:50px;
        z-index: -50;
    }

    .container {
        display: grid;
        padding-bottom: 60px;
        position: relative;
        grid-template-columns: minmax(360px, 1fr) 260px 305px;
        grid-column-gap: 30px;
        grid-template-areas:
            "performance specs select";

        @media (min-width: 1360px) {
            width: 1300px !important;
        }

        @media (min-width: 991px) and (max-width: 1360px) {
            grid-column-gap: 20px;
            max-width: 1340px;
            width: auto;
            padding-right: 30px;
            padding-left: 30px;
        }

        @media (min-width: 767px) and (max-width: 991px) {
            max-width: 570px;
        }

        @media (max-width: 991px) {
            grid-template-areas:
                "select"
                "performance"
                "specs";
            grid-template-columns: 100%;
        }
    }

    .back-step.visible-lg.visible-md {
        left: 20px;

        @media (min-width: 991px) and (max-width: 1200px) {
            left: 0px;
        }
    }

    &__heading {
        color: $white;
        font-size: 24px;
        font-weight: bold;
        margin-top: 0;
        margin-bottom: 30px;
        text-transform: uppercase;

        @media (max-width: 580px) {
            font-size: 14px;
            margin: 25px 0;
        }
    }

    &__performance {
        grid-area: performance;
    }

    &__specs {
        grid-area: specs;
        max-width: 260px;

        @media (max-width: 991px) {
            max-width: 100%;
        }
    }

    &__select {
        grid-area: select;
    }

    &__includes {
        display: none;

        @media (max-width: 991px) {
            display: block;

            .build-includes__heading {
                font-size: 14px;
                margin-bottom: 20px;
                font-weight: bold;
            }
        }

        .includes-loading {
            position: relative;

            .loading {
                position: absolute;
            }
        }
    }

    hr {
        border-color: rgba(255, 255, 255, 0.2);
    }
}
</style>
